<template>
    <div>
        <zoom-client
            v-if="cAbleToView"
            :course-id="cCourseId"
            :leave-url="cLeaveUrl"
            :live-class-id="cLiveClassId"
            :userId="cUserId"
            :fingerprint="cFingerprint"
        />

        <div
            v-else
            class="insufficient-info-error"
        >
            <a :href="cLeaveUrl">
                Lütfen bu pencereyi kapatıp tekrar oturum açmayı deneyin.
            </a>
        </div>
    </div>
</template>

<script>
import ZoomClient from '@/components/ZoomClient.vue'

export default {
    name: 'Home',

    components: {
        ZoomClient
    },

    computed: {
        cAbleToView () {
            return this.cRawIncomingInfo && this.cIncomingInfo && this.cIsIncomingInfoInTime
        },

        cRawIncomingInfo () {
            return this.$route.params.incomingInfo
        },

        cIncomingInfo () {
            try {
                // URL decode the parameter first, then decode base64
                const decodedParam = decodeURIComponent(this.cRawIncomingInfo)
                return JSON.parse(atob(decodedParam))
            } catch (error) {
                console.error('Error decoding incomingInfo:', error)
                return null
            }
        },

        cCourseId () {
            return this.cIncomingInfo?.course
        },

        cLeaveUrl () {
            return this.cIncomingInfo?.host
        },

        cLiveClassId () {
            return this.cIncomingInfo?.live
        },

        cIncomingInfoTime () {
            return this.cIncomingInfo?.time
        },

        cIsIncomingInfoInTime () {
            if (!this.cIncomingInfoTime) return false
            
            const now = new Date().getTime()
            return this.cIncomingInfoTime + (60 * 1000) > now
        },

        cUserId () {
            return this.cIncomingInfo?.userId
        },

        cFingerprint () {
            return this.cIncomingInfo?.fingerprint
        }
    }
}
</script>

<style scoped>
.insufficient-info-error {
    width: 100%;
    padding: 24px;
    font-weight: bold;
}

.insufficient-info-error a {
    color: white;
}
</style>
